import React from 'react';
import { SsMsFormPropTypes, DEFAULT_OPTION } from './form-helper';
import SingleSelectForm from './single-select-form';
import MultiSelectForm from './multi-select-form';

const SingleOrMultiSelect = ({
  label,
  field,
  required = false,
  disabled = false,
  options,
  formValue,
  onFormChange,
  isMultiSelect = false,
}) => {
  if (isMultiSelect)
    return (
      <MultiSelectForm
        label={label}
        field={field}
        required={required}
        disabled={disabled}
        options={options}
        formValue={formValue}
        onFormChange={onFormChange}
      />
    );

  const valueObj = {
    value: formValue.value[0] ?? '',
    errorMessage: formValue.errorMessage,
  };
  const onSingleChange = (value, hasError) => {
    onFormChange(value ? [value] : [], hasError);
  };
  const ssOptions = [DEFAULT_OPTION, ...options];
  return (
    <SingleSelectForm
      label={label}
      field={field}
      required={required}
      disabled={disabled}
      options={ssOptions}
      formValue={valueObj}
      onFormChange={onSingleChange}
    />
  );
};

SingleOrMultiSelect.propTypes = SsMsFormPropTypes;

export default SingleOrMultiSelect;
